import clsx from 'clsx';
import { ComponentPropsWithoutRef, forwardRef } from 'react';
import styles from './TextArea.module.css';

interface TextAreaProps extends ComponentPropsWithoutRef<'textarea'> {
  error?: boolean;
}

export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
  ({ className, error, ...rest }, ref) => (
    <textarea
      ref={ref}
      className={clsx(styles.textarea, className, { [styles.error]: error })}
      {...rest}
    />
  )
);
